export default __webpack_public_path__ + "static/media/email.fe8ae599.png";